
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import ManageModule from "./components/ManageModule.vue";
import ScienceModule from "./components/ScienceModule.vue";
import GrowthModule from "./components/GrowthModule.vue";
import ManageGrowModule from "./components/ManageGrowModule.vue";
import TalentModule from "./components/TalentModule.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, getItemListJsonLd, injectJsonLd } from "@/utils/seo";

@Component({
  components: {
    ApplyForm,
    ManageModule,
    ScienceModule,
    GrowthModule,
    ManageGrowModule,
    TalentModule,
    Breadcrumb
  }
})
export default class Accompany extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "咨询陪跑 | 管理微咨询·科学经营·人才·管理·增长陪跑 - 光华赋能",
      description:
        "光华赋能20年专注企业管理与培训，提供管理微咨询、科学经营陪跑、人才陪跑、管理陪跑、增长陪跑服务。周期短、见效快、费用低，覆盖企业战略、商业模式、股权设计、组织优化、绩效管理、薪酬体系、企业文化等领域。",
      keywords:
        "咨询陪跑,管理微咨询,企业咨询,战略咨询,股权设计,组织优化,绩效管理,薪酬体系,企业文化,企业陪跑,光华赋能",
      path: "/accompany",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "咨询陪跑" }
      ],
      jsonLd: getServiceJsonLd({
        name: "企业咨询陪跑",
        description:
          "提供管理微咨询、科学经营陪跑、人才陪跑、管理陪跑、增长陪跑服务，覆盖战略、股权、组织、绩效、薪酬、文化等领域。",
        category: "企业管理咨询"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/9e5e8f4e97cf740b0b43ed8226bdacfb.png";
  tabIndex: any = 0;
  List = [{ title: "咨询陪跑", url: "" }];
  applyType = "";
  @Watch("$route.query.tab")
  tabChange() {
    this.init();
  }
  created() {
    console.log(123456);

    this.init();
  }
  init() {
    console.log("this.$route.query.tab", this.$route.query.tab);

    this.tabIndex = this.$route.query.tab ? Number(this.$route.query.tab) : 0;
    if (this.tabIndex == 0) {
      this.List = [{ title: "管理微咨询", url: "" }];
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.List = [{ title: "科学经营陪跑", url: "" }];
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.List = [{ title: "人才陪跑", url: "" }];
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.List = [{ title: "管理陪跑", url: "" }];
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.List = [{ title: "增长陪跑", url: "" }];
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  changeTab(index: number) {
    this.tabIndex = index;
    if (this.tabIndex == 0) {
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "咨询培训，微咨询，科学经营陪跑，人才陪跑，管理陪跑，增长陪跑"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "体系僵硬、人才断层、效率底下、战略受阻、管理陪跑，管理微咨询，增长陪跑，科学经营陪跑，人才陪跑，共建商学院，人才梯队，人才密度，人才敬业度，内生动力，高质量发展，体系化，系统化，发展机制，资源，能力，经验，目标管理，组织体系（含薪酬、绩效、股权、主流程等）人才体系，文化体系，组织体系人才管理体系，绩效体系，薪酬激励体系，内部流程体系，文化体系"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "咨询和陪跑有什么区别？",
          answer: "光华赋能的「咨询」和「陪跑」是两种不同的服务模式。核心目标不同：咨询侧重于解决企业的实际问题，是「问题导向」的；陪跑侧重于构建企业的核心能力，是「能力导向」的。时间周期不同：咨询是短期、项目制的，通常从几周到几个月不等；陪跑是中长期的，通常6个月到3年甚至更长，科学经营陪跑就是3年起步。交付形式不同：咨询的交付物是解决方案，包括诊断报告、战略规划书、制度手册等文档类成果；陪跑的交付物是达成成果，包括业绩增长、团队能力提升、体系落地等实际经营成果。参与度不同：咨询保持客观中立，不介入企业日常管理；陪跑深度介入客户的日常会议、执行细节，和团队一起扛压力，咨询师是「编外高管」角色。风险承担不同：咨询对方案的专业性负责；陪跑对方案的结果和落地效果负责，部分服务采用「基础服务费+业绩增量提成」的对赌模式。适用场景不同：咨询适用于解决明确、结构化的问题，如股权设计方案、薪酬体系设计、组织架构优化等；陪跑适用于解决复杂、动态的问题，如企业持续增长、战略到执行全体系落地、组织能力系统性提升等。"
        },
        {
          question: "光华有哪五大陪跑服务？分别适合什么企业？",
          answer: "光华咨询陪跑包含五大陪跑服务：1.增长陪跑——助力业务持续增长，以「科学经营——增长飞轮」为主线，采用「调焦—锚定—蓄势—聚能—引爆」五步法，适合营收规模较大、追求高速增长且愿意对赌结果的企业，服务周期1年，项目费用50万/年（30万基础服务费+20万增量对赌绩效奖金+超额奖励金）。2.科学经营™陪跑——用科学经营助推企业高质量发展，以科学经营「12349」系统框架为主线，适合上市（准上市）企业、行业头部企业、成长型企业，需要系统化经营升级与长期增长的企业，服务周期3年，项目费用500万/3年（260万基础服务费+240万增量对赌绩效奖金+超额奖励金）。3.企业联席增长长官——一年周期形成增长闭环，围绕「大增长七大核心要素」及「分拆对™工作法」，适合营收在千万级以上、希望突破增长瓶颈或构建第二曲线的企业，服务周期1年，项目费用19.8万/年。4.分拆对™工作法落地辅导——目标解码到执行落地一致性，通过分目标、拆动作、对能力三个动作，让目标解码到策略行动到落地能力结构性一致，适合创业型/成长型企业，急需建立目标管理体系和执行文化的团队，服务周期1年，项目费用9.9万/年。5.管理陪跑——助力企业人效持续提升，以「科学经营——效率飞轮」相关模块为主线，包含战略分析、组织管理、薪酬管理、绩效管理、股权激励、人才发展、文化建设、流程优化八大管理模块，适合管理上存在基础薄弱、管理短板明显的各类企业。"
        },
        {
          question: "科学经营陪跑的12349框架是什么？",
          answer: "科学经营陪跑以科学经营「12349」系统框架为主线，这是光华赋能经过23年企业经营研究总结出的中国企业高质量发展底座理论。1个视角：业务视角（Business），要求企业所有经营管理活动都必须从业务出发、为业务服务，避免陷入「为管理而管理」的误区。2个飞轮：增长飞轮和效率飞轮。增长飞轮关注「如何做大蛋糕」，通过市场洞察、战略意图、创新焦点、业务设计等模块驱动企业持续增长；效率飞轮关注「如何分好蛋糕」，通过关键任务、正式组织、人才、氛围与文化等模块提升组织运营效率。两个飞轮相互驱动、循环增强。3个动作：分目标、拆动作、对能力（分拆对™工作法）。分目标是将公司战略目标从上到下、从大到小分解到各部门和各岗位；拆动作是将目标拆解为关键动作、行动方案和具体节点；对能力是确保组织能力、人才能力与目标和动作相匹配。4个角度：财务（F）、客户（C）、内部流程（I）、学习与成长（L），这是BSC平衡计分卡的四个维度，被《哈佛商业评论》誉为「近75年来最伟大的管理工具」。9个模块：差距分析、战略意图、市场洞察、创新焦点、人才、关键任务、正式组织、业务设计、氛围与文化，这是BLM业务领先模型的九大模块，分为战略层面和执行层面。配套18大落地工具和36个关键数据指标。"
        },
        {
          question: "增长陪跑的五步法是什么？费用怎么算？",
          answer: "增长陪跑以「科学经营——增长飞轮」为主线，通过「调焦—锚定—蓄势—聚能—引爆」五步法协助企业实现业绩快速增长。1.调焦：目前在哪里？通过深入企业调研，全面了解企业当前的经营状况，包括营收规模、盈利水平、市场地位、客户定位、产品组合、流量结构、价值主张、业务体系等，精准定位企业当前所处的发展阶段和面临的核心问题。2.锚定：准备去哪里？在清晰认识现状的基础上，帮助企业明确增长目标和方向，包括确定未来3-5年的战略目标、找到增长突破口、明确价值主张、优化业务价值曲线，形成清晰的增长路线图。3.蓄势：变化在哪里？分析企业实现增长目标需要做出哪些改变，包括客户定位的精准化、产品组合的H1/H2/H3分层、流量入口和路径的清晰化、业务体系的优化和激励性提升，为增长爆发积蓄能量。4.聚能：怎么去那里？制定具体的增长策略和行动方案，包括市场洞察的深化、增长路径的设计、业务创新的推进、业务团队的打造，将增长目标转化为可执行的关键任务和行动计划。5.引爆：实现增长突破。通过陪跑团队与企业团队的共同执行，推动增长策略落地，实现业绩的快速增长和突破。增长陪跑前后对比：陪跑前客户定位不清晰、产品组合层次模糊、流量打乱战、价值主张不清晰、业务体系混乱；陪跑后客户定位精准清晰、产品组合H1/H2/H3分层明确、流量入口路径清晰、价值主张清晰、业务体系优化且激励性不断提升。费用计算：增长陪跑服务周期1年，项目费用为50万/年，采用「基础服务费+业绩增量提成」的对赌模式，具体构成为：30万基础服务费+20万增量对赌绩效奖金+超额奖励金。"
        },
        {
          question: "分拆对工作法是什么？能解决什么问题？",
          answer: "分拆对™工作法是光华赋能董事长方永飞老师独创的战略解码与执行落地先进工作法，是科学经营™方法论的核心落地工具，被誉为「一把尖刀」，主要解决企业战略与执行脱节的问题。分拆对的核心内涵是「分目标、拆动作、对能力」三个动作，通过「二分二拆二对」的具体方法，让目标解码到策略行动到落地能力结构性一致。二分（分目标）：一分——目标从公司到部门到员工从上往下分，将公司战略目标层层分解到各部门和各岗位；二分——目标从大往小分F1/F2/F3，将大目标拆解为阶段性、可执行的子目标。二拆（拆动作）：一拆——F拆C，拆关键动作、拆障碍、拆打法，将目标转化为关键举措和行动策略；二拆——C拆节点，拆行动方案、拆小工具，将策略进一步拆解为具体的行动方案、时间节点和操作工具。二对（对能力）：一对——能力从公司到部门到员工对齐，确保各层级的能力与目标相匹配；二对——能力对齐C/I/L（客户、内部流程、学习与成长），确保组织能力的全面发展。配套「四表二会」：四表包括《BSC大表》《行动方案表》《BSC绩效合约表》《必须要打赢的仗》；二会包括共创会和经营分析会。分拆对能解决的核心问题：告别企业中常见的「三各」乱象——规划阶段「各有各想法，各有各道理」导致战略无法共识；落地阶段「各有各做法，各有各不满」导致执行混乱；复盘阶段「各有各委屈，各有各说法」导致无法持续改进。"
        },
        {
          question: "光华企业管理咨询有哪些模块？价格如何？",
          answer: "光华企业管理咨询专注解决成长型企业管理困惑，以积木化的形式为企业量身打造个性化的咨询组合方案。8大咨询模块覆盖企业管理的核心领域：1.企业战略——战略分析、战略选择、战略规划、战略实施；2.商业模式——商业模式设计、创新、优化；3.股权设计——股权架构设计、股权激励方案、合伙人制度；4.组织优化——组织架构设计、部门职责梳理、岗位设置、权责体系；5.内控管理——内部控制体系建设、风险管控、流程规范；6.绩效管理——绩效体系设计、KPI分解、绩效考核、绩效改进；7.薪酬体系——薪酬策略、岗位分类分级、薪酬结构设计、薪酬制度；8.企业文化——使命愿景价值观梳理、文化手册、文化落地机制。4大明星模块是企业高频需求：股权设计（独创「合伙人三层进阶设计法」和「股权激励10D模型」）、绩效管理（分解目标关键举措关键任务，通过管理措施实现目标绩效）、薪酬体系（拟定符合企业发展需求的薪资政策和薪酬体系）、组织优化（构建以客户需求为导向的流程型组织架构）。3大服务优势：周期短（10年经验专业咨询师+庞大案例库，快速锁定核心病结）、见效快（陪伴式辅导+信息化落地，精准打击内部问题）、费用低（有别于其他咨询机构的高收费标准，低成本+高效能）。价格：企业管理咨询按模块报价，根据企业规模和需求定制方案，具体价格需专家团队调研后确定。单项咨询产品有明确价格参考，如《战略定位》6.8万、《战略蓝图》2.98万、《SWOT931》6.8万/每条业务链、《大单品》9.9万、《流量矩阵》9.9万、《FFS业务链》9.9万等。"
        }
      ])
    );
    // 注入 ItemList JSON-LD（相关知识推荐）
    injectJsonLd(
      "jsonld-related-knowledge",
      getItemListJsonLd([
        { name: "科学经营™", url: "/scientific-management" },
        { name: "BLM方法论", url: "/blm" },
        { name: "分拆对™工作法", url: "/fenchaidui" }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
